// данные для формы проекта
import axios from 'axios'
import i18n from '../plugins/i18n'

export default {
  // данные для формы создания обращения
  getAppealFormData() {
    return axios.get(`${i18n.locale}/api/public/appeal/formData`)
  },
  // создание обращения
  createAppeal(data, recaptcha) {
    return axios.post(`${i18n.locale}/api/public/appeal/create?recaptchaToken=${recaptcha}`, data)
  },
  // данные об обращении
  getAppeal(id) {
    return axios.get(`${i18n.locale}/api/public/appeal/${id}`)
  },
  // список обращений
  getAppealsList(params) {
    let param = ''

    for (let field in params) {
      param += `${field}=${params[field]}&`
    }

    return axios.get(`${i18n.locale}/api/appeal/appealsList?${param}`)
  },
  // данные для фильтрации
  getAppealFilterFormData() {
    return axios.get(`${i18n.locale}/api/appeal/filterFormData`)
  },
  // данные об обращении
  getAppealInfo(id) {
    return axios.get(`${i18n.locale}/api/appeal/info/${id}`)
  },
  // получаем данные для формы причина отказа
  getRejectFormData() {
    return axios.get(`${i18n.locale}/api/appeal/rejectFormData`)
  },
  // меняем статус у обращения
  changeStatus(id, data) {
    return axios.post(`${i18n.locale}/api/appeal/status/${id}`, data)
  },
  // Получение данных для страницы статистики
  getAppealStatisticData() {
    return axios.get(`${i18n.locale}/api/public/appealStatisticData`)
  },
  // Получение данных для страницы статистики
  getAppealStatistic(year) {
    return axios.get(`${i18n.locale}/api/public/appealStatistic/${year}`)
  },
  // данные формы для редактирования обращения
  getReferencesData (reference) {
    return axios.get(`${i18n.locale}/api/appeal/references?ref=${reference}`)
  },
  // обновление обращения
  updateAppeal(data, id) {
    return axios.patch(`${i18n.locale}/api/appeal/updateAppeal/${id}`, data)
  },
  // обновление обращения
  updateReplyFiles(data, id) {
    return axios.post(`${i18n.locale}/api/appeal/updateReplyFiles/${id}`, data)
  },
  // Удаление файла у текущего обращения
  deleteFile (id, fileName) {
    return axios.get(`${i18n.locale}/api/appeal/deleteFile/${id}/${fileName}`)
  },
  // предпросмотр сообщения
  previewMessage(id) {
    return axios.get(`${i18n.locale}/api/appeal/previewMessage/${id}`)
  },
  // отправка ответа
  sendReply(id, data) {
    return axios.post(`${i18n.locale}/api/appeal/sendReply/${id}`, data)
  }
}
